module.exports = __webpack_public_path__ + "static/img/logo.bf8fca26.png";